var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "buy-panel-product-info"
  }, [_c('span', {
    class: ['buy-panel-product-info-model', {
      'tmall': _vm.isModelPriceLabelPositionCentered && _vm.isFavoritesOnly || _vm.isModelPriceLabelPositionCentered && _vm.checkUGC & !_vm.tmallIsUGCMS
    }]
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm.isModelPriceLabelPositionCentered && !_vm.isFavoritesOnly || !_vm.isModelPriceLabelPositionCentered ? _c('span', {
    staticClass: "buy-panel-product-info-price"
  }, [_c('currency-wrapper', {
    attrs: {
      "priceRaw": _vm.$store.state.buyPanel.price.string
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }